import moment from 'moment';
import { cloneDeep, filter, get, isNil, isUndefined, merge } from 'lodash';
import React, { PropTypes } from 'react';
import ValidatedForm from '../../../../../../common/components/ValidatedForm';
import DateInputDropDown from '../../../../../../common/components/DateInputDropDown';
import TextArea from '../../../../../../common/components/c_TextArea';
import FlatButton from '../../../../../../common/components/c_FlatButton';

export default class Gap extends ValidatedForm {
  static propTypes = {
    gap : PropTypes.object.isRequired,
    onChange : PropTypes.func.isRequired,
    removeListItem : PropTypes.func.isRequired,
    validation: PropTypes.object.isRequired,
    index: PropTypes.number
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      validation: merge({},
        cloneDeep(props.validation),
        this.CustomValidation
      )
    };
  }

  get CustomValidation() {
    const component = this;

    const CustomValidator = function() {
      this.gapEnd = {
        custom: {
          func: (val) => {
            const gapStart = get(component.formModel, 'gapStart');
            const gapEnd = isNil(get(component.formModel, 'gapEnd')) || !get(component.formModel, 'gapEnd') || val
            const yearsDiff = moment(gapEnd).diff(moment(gapStart), 'years');
            const monthsDiff = moment(gapEnd).diff(moment(gapStart), 'months');
            return yearsDiff !== 0 || monthsDiff !== 0;
          },
          message: 'Please select a different end date.'
        }
      };
    };

    return new CustomValidator();
  }

  // Override ValidatedForm.formModel method
  get formModel() {
    return merge({}, get(this, 'props.gap'), get(this, `props.tempState.employmentGaps[${this.props.gap.clientId}]`));
  }

  handleRemove(clientId) {
    return (event) => this.props.removeListItem(clientId);
  }

  handleUpdate = (clientId, prop) =>
    (model, field, event, value) => this.props.onChange(clientId, prop, event, value)


  renderAttributes(prop, label, updateOn = 'onBlur', valueOn = 'defaultValue') {
    return {
      floatingLabelText: label,
      [valueOn]: (this.props.gap[prop]),
      isDirty: !!get(this.state, `validation.${prop}.errors[0]`, false),
      errorText: get(this.state, `validation.${prop}.errors[0]`),
      [updateOn]: this.validateUpdate(this.props.model, prop, this.handleUpdate(this.formModel.clientId, prop))
    };
  }

  render() {
    const gap = this.props.gap;
    const index = this.props.index || gap.clientId;
    const yearsDiff = moment(gap.gapEnd).diff(moment(gap.gapStart), 'years');
    const monthsDiff = moment(gap.gapEnd).diff(moment(gap.gapStart), 'months');
    const totalGapDiff = yearsDiff ? `Total: ${yearsDiff} years` : `Total ${monthsDiff} months`;

    return (
      <div
        key={gap.clientId}
        className='employment-gap'
      >
        <div className='date-input-menus'>
          <DateInputDropDown
            autoOk
            ref='gapStart'
            data-id={`Employed From ${index}`}
            dateFormat={'MonthYear'}
            hintText={'12/1999'}
            {...this.renderAttributes('gapStart', 'Period of Gap From', 'onChange')}
            underlineStyle={{margin: '-1px 10px 0 0'}}
            iconStyle={{right: '0px', fill: 'rgb(33, 35, 38)'}}
            labelStyle={{paddingLeft: '0px'}}
          />
          <DateInputDropDown
            autoOk
            ref='gapEnd'
            data-id={`Employed To ${index}`}
            dateFormat={'MonthYear'}
            hintText={'01/2001'}
            minDate={gap.gapStart}
            {...this.renderAttributes('gapEnd', 'Period of Gap To', 'onChange')}
            underlineStyle={{margin: '-1px 10px 0 0'}}
            iconStyle={{right: '0px', fill: 'rgb(33, 35, 38)'}}
            labelStyle={{paddingLeft: '0px'}}
          />
          <div
            className='total-container'
            style={{opacity: gap.gapStart && gap.gapEnd ? 1 : 0}}>
            <div className='total-heading'>{totalGapDiff}</div>
          </div>
        </div>
        <TextArea
          style={{minHeight: '95px'}}
          showCharacterCount
          capitalizedSentences
          maxLength={400}
          description={'Please Explain:'}
          data-id={'employment-gap-explain'}
          {...this.renderAttributes('explanation')}
        />
        <div
          data-id='remove-section'
          className='remove-section text-btn noTextSelect'
          onClick={this.handleRemove(gap.clientId)}
        >
          Remove Employment Gap
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Experience/c_EmploymentGaps/Gap.js